import { types } from "../../types/types";

const initialState = {
  cargada: false,
  presentadaTitularOk: false,
  presentadaFamiliaresOk: false,
  certificadoTitularOk: false,
  certificadoFamiliaresOk: false,
  loading: false,
  error: null,
};


export const documentacionPresentadaReducer = (state = initialState, action) => {   
    switch (action.type) {
        case types.documentacionCargadaTitularTraerCargadaStart:
            return {
                presentadaFamiliaresOk: false,
                presentadaTitularOk: false,
                loading: true,
                error: null,
                cargada: false,
              };
          case types.documentacionCargadaTitularTraerCargadaSuccess:
            return {
                ...state,
                loading: false,
                presentadaFamiliaresOk: false,
                presentadaTitularOk: action.payload,
                cargada: true,
              };
          case types.documentacionCargadaTitularTraerCargadaError:
            return {
                ...state,
                loading: false,
                presentadaFamiliaresOk: false,
                presentadaTitularOk: false,
                cargada: false,
              };
          case types.limpiarEstadoDocumentacionCargadaTitular:
            return {
                loading: false,
                presentadaFamiliaresOk: false,
                presentadaTitularOk: false,
                certificadoFamiliaresOk: false,
                certificadoTitularOk: false,
                cargada: false,
              };
          case types.documentacionCargadaFamiliaresTraerCargadaStart:
            return {
                presentadaFamiliaresOk: false,
                presentadaTitularOk: false,
                loading: true,
                error: null,
                cargada: false,
              };
          case types.documentacionCargadaFamiliaresTraerCargadaSuccess:
            return {
                ...state,
                loading: false,
                presentadaFamiliaresOk: action.payload,
                presentadaTitularOk: false,
                cargada: true,
              };
          case types.documentacionCargadaFamiliaresTraerCargadaError:
            return {
                ...state,
                loading: false,
                presentadaFamiliaresOk: false,
                presentadaTitularOk: false,
                cargada: false,
              };
          case types.limpiarEstadoDocumentacionCargadaFamiliares:
            return {
                loading: false,
                presentadaFamiliaresOk: false,
                presentadaTitularOk: false,
                certificadoFamiliaresOk: false,
                certificadoTitularOk: false,
                cargada: false,
              };
          case types.certificadosCargadaTitularTraerCargadaStart:
            return {
                ...state,
                certificadoFamiliaresOk: false,
                certificadoTitularOk: false,
                loading: true,
                error: null,
                cargada: false,
              };
          case types.certificadosCargadaTitularTraerCargadaSuccess:
            return {
                ...state,
                loading: false,
                certificadoFamiliaresOk: false,
                certificadoTitularOk: action.payload,
                cargada: true,
              };
          case types.certificadosCargadaTitularTraerCargadaError:
            return {
                ...state,
                loading: false,
                certificadoFamiliaresOk: false,
                certificadoTitularOk: false,
                cargada: false,
              };
          case types.limpiarEstadoCertificadosCargadaTitular:
            return {
                loading: false,
                certificadoFamiliaresOk: false,
                certificadoTitularOk: false,
                presentadaFamiliaresOk: false,
                presentadaTitularOk: false,
                cargada: false,
              };
        default:
          return state;
      }
};